import script from "./edit_deliverable.vue?vue&type=script&setup=true&lang=ts"
export * from "./edit_deliverable.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__